<ng-container *transloco="let t">
  <ng-container
    *ngIf="{
      licenses: licenses$ | async
    } as vm"
  >
    <ul class="side-menu">
      <app-navigation
        class="ml-3"
        [selectedChild]="selectedChild$ | async"
        [results]="results$ | async"
        [teachersResults]="teachersResults$ | async"
        [selectedResult]="selectedResult$ | async"
        [papLocked]="papLocked$ | async"
      ></app-navigation>
    </ul>
    <div class="side-menu">
      <div class="demo-switch-wrapper mb-4" *ngIf="showDemoSwitch$ | async">
        {{ t('shared/tryApp') }}
        <button (click)="switchDemoToDemoKindergarten()" class="btn btn-primary">
          {{ t('shared/demoKindergarten') }}
        </button>
      </div>
      <ul *ngIf="isTeacher" class="">
        <li *ngIf="showManagementApp$ | async">
          <a
            class="btn btn-outline-primary btn-sm mng-btn mb-3 redirect-btn"
            [href]="mngAppUrl.url"
            [target]="mngAppUrl.target"
            (mouseover)="changeImage('assets/img/logo/logo.png', externalApps.MANAGEMENT)"
            (mouseleave)="changeImage('assets/img/logo/isophi-mng_wheel_logo_256.png', externalApps.MANAGEMENT)"
          >
            <img class="sidemenu_icon" [src]="imageSrcManagement" alt="Management logo" />
            <span class="fw-bold side-menu__label">{{ t('shared/managementApp') }}</span>
          </a>
        </li>
        <li *ngIf="showChildPortfolio$ | async">
          <a
            class="btn btn-outline-primary btn-sm mng-btn mb-3 redirect-btn"
            [href]="childrenPortfolioUrl.url"
            [target]="childrenPortfolioUrl.target"
            (mouseover)="changeImage('assets/img/logo/logo.png', externalApps.CHILD_PORTFOLIO)"
            (mouseleave)="changeImage('assets/img/logo/isophi-mng_wheel_logo_256.png', externalApps.CHILD_PORTFOLIO)"
          >
            <img class="sidemenu_icon" [src]="imageSrcChildPortfolio" alt="Management logo" />
            <span class="fw-bold side-menu__label">{{ t('shared/childrenPortfolio') }}</span>
          </a>
        </li>
        <li *ngIf="showTeacherApp$ | async">
          <a
            class="btn btn-outline-primary btn-sm redirect-btn"
            [href]="teacherAppUrl.url"
            [target]="teacherAppUrl.target"
            (mouseover)="changeImage('assets/img/logo/logo.png', externalApps.TEACHER)"
            (mouseleave)="changeImage('assets/img/logo/isophi-diag_wheel_logo_256.png', externalApps.TEACHER)"
          >
            <img class="sidemenu_icon" [src]="imageSrcTeacher" alt="Teacher logo" />
            <span class="fw-bold side-menu__label">{{ t('shared/diagnostics') }}</span>
          </a>
        </li>
      </ul>
    </div>
  </ng-container>
</ng-container>
